/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import * as ROUTES from '@constants/routes';
import { onboardinErrorObject } from '@constants/errorObjects';
import { getTokenFromParams } from '@helpers/utils';

import LoginHeader from '@components/LoginHeader';

import Header from '@components/Forms/Header';
import useBreakpoint from '@hooks/breakpoint';
import { resetPassword, validateTokenResetPassword } from '@services/login-service';
import { setToken, setInitialOnboardingState } from '@store/onboarding/actions';
import { showError } from '@store/common/actions';
import { useDispatch, useSelector } from 'react-redux';

import { RePasswordForm } from 'components';

const Container = styled.div`
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;

const ResetPasswordForm = () => {
  const { token } = useSelector((state) => state.onboarding);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [errorEndpoint, setErrorEndpoint] = useState(false);
  const [ready, setReady] = useState(true);
  const { mobile } = useBreakpoint();

  const { t } = useTranslation();

  const handleSuccessCreatePassword = () => {
    history.push(ROUTES.SUCCESS_RESET_PASSWORD);
    // TODO: LOGICA DESPUES DE CREAR PASSWORD
  };

  const handleErrorCreatePassword = (error) => {
    const customMessage =
      error.message.message === 'Password invalid'
        ? t('passwordForms.errorForPassword')
        : t('passwordForms.errorForService');

    const { token } = error.message;
    dispatch(setToken(token));
    if (error.message.message === 'Password invalid') {
      setErrorEndpoint(true);
    } else {
      setErrorEndpoint(false);
    }

    dispatch(showError(onboardinErrorObject({ message: customMessage })));
  };

  const handleSuccessValidateToken = (response) => {
    dispatch(setToken(response.token));
    setReady(true);
  };

  const handleErrorValidateToken = (error) => {
    dispatch(showError(onboardinErrorObject(error)));
    history.push(ROUTES.LOGIN);
  };

  useEffect(() => {
    const token = getTokenFromParams(location);
    dispatch(setInitialOnboardingState());
    dispatch(setToken(token));
    validateTokenResetPassword({ token }, handleSuccessValidateToken, handleErrorValidateToken);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (password) => {
    try {
      await resetPassword(
        { token, password },
        handleSuccessCreatePassword,
        handleErrorCreatePassword
      );
      setReady(true);
    } catch (error) {
      setReady(true);

      dispatch(
        showError(
          onboardinErrorObject({
            message: t('passwordForms.errorForService'),
          })
        )
      );
    }
  };

  const initialState = {
    clickedSecondInput: false,
  };

  const [state, setState] = useState(initialState);

  const handleSecondInputClick = () => {
    setState({ ...state, clickedSecondInput: true });
  };

  const handleFirstInputClick = () => {
    setErrorEndpoint(false);
    setState({ ...state, clickedSecondInput: false });
  };

  return (
    <>
      {ready && (
        <Container>
          {mobile ? <Header withoutTextMobile isResetPass /> : <LoginHeader isResetPass />}
          <RePasswordForm
            title={t('passwordForms.titleChangePassword')}
            subtitle={<Trans i18nKey="passwordForms.subtitleTitleChangePassword" />}
            handleSubmit={handleSubmit}
            errorEndpoint={errorEndpoint}
            handleFirstInputClick={handleFirstInputClick}
            handleSecondInputClick={handleSecondInputClick}
            state={state}
            showCheckPrivacyPolicy={false}
            viewTyc={false}
            showPolicies={false}
          />
        </Container>
      )}
    </>
  );
};

export default ResetPasswordForm;
